import { theme } from '@/styles/theme';

export const styles = {
  container: { width: '100%', marginTop: -2 },
  subtitle: { fontSize: '14px', color: theme.palette.gray.main },
  listContainer: {
    paddingTop: 4,
  },
  iconLeft: {
    fontSize: '2rem',
    marginRight: 1.5,
  },
  photo: {
    fontSize: 16,
    backgroundColor: 'white',
    color: theme.palette.focus.main,
    boxShadow: 3,
    marginLeft: -1,
  },
  editIcon: {
    color: theme.palette.gray.main,
    fontSize: '2rem',
  },
  title: {
    flexGrow: 1,
  },
  totalText: {
    fontSize: 18,
  },
  valuesText: { fontSize: 13 },
  lineInText: { textDecoration: 'line-through' },
  higherValue: { fontSize: 18, color: 'black' },
  valuesTypographies: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.gray.main,
    gap: 1,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    paddingTop: 2,
    paddingBottom: 2,
  },
  footer: {
    flexGrow: 1,
    paddingBottom: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  totalValueBox: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 4,
  },
  totalValueText: {
    flexGrow: 1,
    color: theme.palette.gray.main,
  },
  disabled: {
    fontSize: '2rem',
  },
};
